import type { ItemSelecionado } from '@/types/servico';

export type ErroValidacaoServicos = 'multiplos_por_hora';

/**
 * Regras de composição de serviços numa OS.
 * No máximo 1 serviço `por_hora` por OS — o cronómetro de parede único da visita
 * não consegue repartir tempo entre vários serviços por hora de forma justa.
 * Serviços fixos/m² não têm limite.
 */
export function validarServicosOS(
  itens: ItemSelecionado[],
): { ok: boolean; erro?: ErroValidacaoServicos } {
  const porHora = itens.filter((i) => i.servico.tipo_preco === 'por_hora').length;
  if (porHora > 1) {
    return { ok: false, erro: 'multiplos_por_hora' };
  }
  return { ok: true };
}
